import React from "react";
import PropTypes from "prop-types";
import i18next from "i18next";
import {CommandContext, GlobalDebugMode} from "@mnjsplatform/data";
import {default as PlaceholderWrapperInternal} from "@mnjsplatform/components/lib/common/PlaceholderWrapper";
import Instruction from "./Instruction";
import {connect} from "react-redux";
import reactToText from "react-to-text";

class PlaceholderWrapper extends React.Component {
    static contextType = CommandContext;

    constructor(props) {
        super(props);
        this.state = {
            settings: null
        }
    }

    componentDidMount() {
        this.initialize()
    }

    initialize = async () => {
        //console.log(`menuId:${this.props.menuId} ContextKey:${this.context.key}`);
        /*Ключ:
            WorkSiteId – идентификатор РМ
            CommandItemId – идентификатор команды в РМ
            PlaceholderId – идентификатор фрейма в команде
            PlaceholderName – наименование фрейма*/
        const menuItem = this.props.menuId ? this.props.menuItems.find(mi => mi.MenuID === this.props.menuId)
            : this.props.menuItems.find(mi => mi.AppCommand && mi.AppCommand.Param1 === this.context.key);
        this.command = menuItem?.AppCommand;
        this.placeholderId = (this.props.commandInstruction ? "COMMAND_HELP" : "") || this.props.placeholderId;
        //console.log(`this.placeholderId:${this.placeholderId} this.command:${JSON.stringify(this.command)}`);
        const cleanTitle = reactToText(this.props.title);
        let title = (this.props.commandInstruction ? i18next.t("Command_Instruction") : "") || this.props.staticTitle || cleanTitle || this.props.title;
        if (this.props.getTitle) {
            title = this.props.getTitle();
        }

        this.key = {
            WorkSiteId: this.context.workplaceId,
            CommandItemId: this.command.ID,
            PlaceholderId: this.placeholderId,
            PlaceholderName: title
        };
        await this.props.dispatch(this.props.dataItemInfo.reset());
        await this.props.dispatch(this.props.dataItemInfo.execute(this.key));
        this.setState({settings: this.props.dataItemInfo.getRow(0)})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.menuId !== prevProps.menuId) {
            this.initialize();
        }
    }

    render() {
        if (!this.state.settings) {
            return null;
        }
        if (this.state.settings["IsPlaceholderVisible"] != null && this.state.settings["IsPlaceholderVisible"] !== 1) {
            return null;
        }
        const customTitle = this.state.settings["PlaceholderNameUser"] || this.props.title;
        const instruction = this.props.showInstruction && this.command &&
            <Instruction instructionId={this.props.instructionId} {...this.state.settings}/>;
        return (this.props.commandInstruction
                ? instruction
                : <PlaceholderWrapperInternal placeholderId={this.placeholderId} {...this.props} title={customTitle}>
                    {GlobalDebugMode && JSON.stringify(this.key)}
                    {instruction}
                    {this.props.children}
                </PlaceholderWrapperInternal>
        );
    }
}

PlaceholderWrapper.propTypes = {
    placeholderId: PropTypes.string,
    title: PropTypes.any,
    getTitle: PropTypes.func,
    showInstruction: PropTypes.bool,
    commandInstruction: PropTypes.bool,
    staticTitle: PropTypes.string,
    showHeaderTitle: PropTypes.bool,
    showSplitterLine: PropTypes.bool,
    collapsed: PropTypes.bool,
    canCollapse: PropTypes.bool,
    style: PropTypes.object,
    className: PropTypes.string,
    headerStyle: PropTypes.object,
    onCollapse: PropTypes.func,
    onExpand: PropTypes.func,
    classNameOpen: PropTypes.string,
    classNameClose: PropTypes.string,
    iconPlacement: PropTypes.string,
    addHeaderTitle: PropTypes.object,
    instructionId: PropTypes.string,
    menuId: PropTypes.string,
    menuItems: PropTypes.array,
    dispatch: PropTypes.func
};

PlaceholderWrapper.defaultProps = {
    showInstruction: true,
    commandInstruction: false
};

function mapStateToProps(state, ownProps) {
    return {
        menuItems: state.appState.appParams.menu.Items,
        dataItemInfo: state.instructionState.PersOffHelp_GetHelpForPO
    }
}

export default connect(mapStateToProps)(PlaceholderWrapper);